import { render, staticRenderFns } from "./date-picker-panel.vue?vue&type=template&id=bf05ae36&scoped=true"
import script from "./date-picker-panel.vue?vue&type=script&lang=ts&setup=true"
export * from "./date-picker-panel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./date-picker-panel.vue?vue&type=style&index=0&id=bf05ae36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf05ae36",
  null
  
)

export default component.exports